// removed by extract-text-webpack-plugin
module.exports = {"slider":"slider_1xVH6","fill":"fill_2MIZI","handle":"handle_269vf","tooltip":"tooltip_3wnYB","vertical":"vertical_2BEZh"};


//////////////////
// WEBPACK FOOTER
// ./app/components/slider/styles.scss
// module id = 505
// module chunks = 1